module.exports = __webpack_public_path__ + "static/HarshAgarwal-c8be0c14befc6504296a026f62cba089.jpg";